import { io } from "socket.io-client";
import { useEffect } from "react";

// const SOCKET_URL = "https://api.luckify.bet/";
const SOCKET_URL = "https://prod-api.luckify.bet/";
const socket = io(SOCKET_URL, {
  transports: ["websocket"],
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
});

export const useSocketEvents = (events) => {
  useEffect(() => {
    const eventHandlers = [];
    events.forEach(({ eventName, handler }) => {
      socket.on(eventName, handler);
      eventHandlers.push({ eventName, handler });
    });
    return () => {
      eventHandlers.forEach(({ eventName, handler }) => {
        socket.off(eventName, handler);
      });
    };
  }, [socket, events]);
};

export default socket;
